import Stack from "@mui/material/Stack"
import { useGetFeedQuery } from "appRedux/slices/feedApiSlice"
import { useGetPopularItemsQuery } from "appRedux/slices/wishItemApiSlice"
import FeedsTemplate from "components/templates/FeedsTemplate"

export default function FeedPage() {
  const getFeedResult = useGetFeedQuery(1)
  useGetPopularItemsQuery()

  return (
    <Stack flexGrow={1} height="100%" paddingBottom="30px">
      <FeedsTemplate
        isLoading={getFeedResult.isUninitialized || getFeedResult.isFetching || getFeedResult.isLoading}
      />
    </Stack>
  )
}
